import {z} from 'zod'

export const equipmentExceptionKindSchema = z.enum([
    'double_booked',
    'long_rental',
    'no_rate',
    'pickup_done_still_out',
    'closed_job_still_out',
    'not_confirmed_out',
    'requirement_unfilled',
    'needs_start_time',
    'not_on_rent_yet',
    'out_of_service_overdue',
])

export type EquipmentExceptionKind = z.infer<typeof equipmentExceptionKindSchema>

const relatedJobRawSchema = z.object({job_id: z.string(), display_id: z.string()})

export const equipmentExceptionRawSchema = z.object({
    kind: equipmentExceptionKindSchema,
    kind_label: z.string(),
    job_id: z.string().nullable(),
    job_display_id: z.string().nullable(),
    job_name: z.string().nullable(),
    customer_name: z.string().nullable(),
    equipment: z.string(),
    detail: z.string(),
    since: z.string().nullable(),
    rental_asset_id: z.string().nullable(),
    other_jobs: z.array(relatedJobRawSchema),
    dispatch_yard_id: z.string().nullable(),
})

export type EquipmentExceptionRaw = z.infer<typeof equipmentExceptionRawSchema>

export const equipmentExceptionsRawSchema = z.object({
    as_of: z.string(),
    exceptions: z.array(equipmentExceptionRawSchema),
})

export type EquipmentExceptionsRaw = z.infer<typeof equipmentExceptionsRawSchema>

export const equipmentExceptionsSchema = equipmentExceptionsRawSchema.transform((raw) => ({
    asOf: raw.as_of,
    exceptions: raw.exceptions.map((row) => ({
        kind: row.kind,
        kindLabel: row.kind_label,
        jobId: row.job_id,
        jobDisplayId: row.job_display_id,
        jobName: row.job_name,
        customerName: row.customer_name,
        equipment: row.equipment,
        detail: row.detail,
        since: row.since,
        rentalAssetId: row.rental_asset_id,
        otherJobs: row.other_jobs.map((job) => ({jobId: job.job_id, displayId: job.display_id})),
        dispatchYardId: row.dispatch_yard_id,
    })),
}))

export type EquipmentExceptions = z.infer<typeof equipmentExceptionsSchema>
export type EquipmentException = EquipmentExceptions['exceptions'][number]

export const waitingForUnitNumberRawSchema = z.object({
    rental_asset_id: z.string(),
    job_id: z.string(),
    job_display_id: z.string(),
    job_name: z.string(),
    customer_name: z.string(),
    vendor_name: z.string(),
    type_name: z.string(),
    start_date: z.string(),
})

export type WaitingForUnitNumberRaw = z.infer<typeof waitingForUnitNumberRawSchema>

export const waitingForUnitNumbersSchema = z.array(
    waitingForUnitNumberRawSchema.transform((row) => ({
        rentalAssetId: row.rental_asset_id,
        jobId: row.job_id,
        jobDisplayId: row.job_display_id,
        jobName: row.job_name,
        customerName: row.customer_name,
        vendorName: row.vendor_name,
        typeName: row.type_name,
        startDate: row.start_date,
    })),
)

export type WaitingForUnitNumber = z.infer<typeof waitingForUnitNumbersSchema>[number]
